import gtinNormalizer from "modules/shared/normalizers/gtin";
import {
  bannerNormalizer,
  startupsNormalizer,
  orderGroupsNormalizer,
  orderUnitsNormalizer,
  platformStatisticsNormalizer,
  productCategoriesNormalizer,
  productsNormalizer,
  externalOrdersNormalizer,
  externalOrderNormalizer,
  merchantAccountsNormalizer,
  merchantStoresNormalizer,
  merchantStoreCoordinatesNormalizer,
  merchantStoreShippingAddressesNormalizer,
  hotOrderUnitsNormalizer,
  notificationsNormalizer,
  productFeedbackTodosNormalizer,
  discountsInKindNormalizer,
  orderChannelableNormalizer,
  productDraftNormalizer,
  shippingUnitNormalizer,
  imageAttachmentNormalizer,
  documentAttachmentNormalizer,
  unpublishedProductPreviewNormalizer,
} from "shared/normalizers";

import { wrapIdHash } from "shared/utils/support";

// Please note that currently you must specify singular mappings too (when needed)
export const normalizersMapping = {
  banner: bannerNormalizer,
  startup: startupsNormalizer,
  orderGroup: orderGroupsNormalizer,
  orderGroups: orderGroupsNormalizer,
  orderUnit: orderUnitsNormalizer,
  orderUnits: orderUnitsNormalizer,
  digitalizedOrders: externalOrdersNormalizer,
  digitalizedOrder: externalOrderNormalizer,
  discountsInKind: discountsInKindNormalizer,
  platformStatistics: platformStatisticsNormalizer,
  productCategories: productCategoriesNormalizer,
  product: productsNormalizer,
  products: productsNormalizer,
  productDraft: productDraftNormalizer,
  shippingUnit: shippingUnitNormalizer,
  shippingUnits: shippingUnitNormalizer,
  orderChannelable: orderChannelableNormalizer,
  unpublishedProductPreview: unpublishedProductPreviewNormalizer,
  merchantAccounts: merchantAccountsNormalizer,
  merchantStores: merchantStoresNormalizer,
  merchantStoreCoordinates: merchantStoreCoordinatesNormalizer,
  merchantStoreShippingAddresses: merchantStoreShippingAddressesNormalizer,
  hotOrderUnits: hotOrderUnitsNormalizer,
  notifications: notificationsNormalizer,
  productFeedbackTodos: productFeedbackTodosNormalizer,
  imageAttachment: imageAttachmentNormalizer,
  documentAttachment: documentAttachmentNormalizer,
  gtin: gtinNormalizer,
};

function ensureNormalizerAvailable(normalizer, name) {
  if (!normalizer) {
    throw new Error(`API normalizer missing for ${name}`);
  }
}

export function normalizeApiToIdHash(
  data,
  name,
  normalizer = normalizersMapping[name],
) {
  ensureNormalizerAvailable(normalizer, name);
  return wrapIdHash(normalizer.normalize(data));
}

export function normalizeApi(
  data,
  name,
  normalizer = normalizersMapping[name],
) {
  ensureNormalizerAvailable(normalizer, name);
  return normalizer.normalize(data);
}
